import React, { Component } from "react";
import styles from "../../thema/style";
import { Link } from "react-router-dom";
export default class PageTitle extends Component {
  render() {
    return (
      <div
        className={`row ${styles.pageTitle}`}
        style={{ flexDirection: "column" }}
      >
        <img
          alt="404 Sayfa bulunamdı"
          src="/images/404.png"
          style={{ marginTop: 50, marginBottom: 0 }}
        />
        <h2 style={{ marginTop: 50, marginBottom: 40 }}>
          Aradığınız Sayfayı Bulamadık
        </h2>
        <Link
          to={"/"}
          className={"btn btn-success"}
          style={{
            padding: [10, 25],
            fontSize: 20,
            marginBottom: 40
          }}
        >
          Anasayfaya Git
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/404.js